import { BaseModule } from '../../helpers/base_module';

export class Contact extends BaseModule {

    
    /**
     * The form container block
     *
     * @private
     * @type {JQuery}
     * @memberof Contact
     */
    private container: JQuery;

    
    /**
     * The form container sizing block
     *
     * @private
     * @type {JQuery}
     * @memberof Contact
     */
    private sizer: JQuery;

    
    /**
     * The length of the animation
     *
     * @private
     * @type {number}
     * @memberof Contact
     */
    private animationDuration: number;


    /**
     * Determines if the form is currently open.
     *
     * @private
     * @memberof Contact
     */
    private formIsOpen = false;

    /**
     * Creates an instance of Contact.
     *
     * @memberof Contact
     */
    constructor() {
        super();
        super.makePublic('contact');
    
        this.sizer             = $('#js-contact__sizer');
        this.container         = $('#js-contact__container');
        this.animationDuration = parseFloat(this.container.css('transition-duration')) * 1000;

        this.setup();
    }


    /**
     * Add's the event listeners for this component.
     *
     * @private
     * @memberof Contact
     */
    private setup() {

        // Toggle the form on click
        const links = $('a[href="#contact"]');
        links.each(({}, link) => {
            $(link).on('click', () => { this.toggleForm(); });
        });

        // If we have the correct hash in the URL, open 'er up
        if(window.location.hash === '#gf_1') {
            this.open();
        }
    }


    /**
     * Toggle the form state.
     *
     * @private
     * @memberof Contact
     */
    private toggleForm() {
        if(this.formIsOpen) {
            this.close();
        } else {
            this.open();
        }
    }


    /**
     * Open the form
     *
     * @private
     * @param {() => void} [callback] Optional callback function
     * @memberof Contact
     */
    private open(callback?: () => void) {
        this.formIsOpen = true;
        const height = this.sizer.outerHeight() as number;
        this.container.height(height);

        setTimeout(() => {
            this.container.height('auto');
            if(callback) callback();
        }, this.animationDuration);
    }


    /**
     * Closes the form
     *
     * @private
     * @param {() => void} [callback] Optional callback function
     * @memberof Contact
     */
    private close(callback?: () => void) {
        this.formIsOpen = false;
        const height = this.sizer.outerHeight() as number;
        this.container.height(height);

        setTimeout(() => {
            this.container.height(0);
        }, 10);

        setTimeout(() => {
            if(callback) callback();
        }, this.animationDuration);
    }
}
